
<!-- Reusable upload-on-select status indicator (FR1/FR5). Pass the control name as context. -->
<ng-template #uploadStatus let-c>
  <div class="mt-1" *ngIf="uploadState[c]">
    <span *ngIf="uploadState[c] === 'uploading'" class="text-secondary small"><i class="fa fa-spinner fa-spin"></i> Uploading…</span>
    <span *ngIf="uploadState[c] === 'uploaded'" class="text-success small"><i class="fa fa-check-circle"></i> Uploaded</span>
    <span *ngIf="uploadState[c] === 'error'" class="text-danger small"><i class="fa fa-times-circle"></i> {{ uploadError[c] || 'Upload failed — please re-select the file.' }}</span>
  </div>
</ng-template>

<div class="row">

  <form *ngIf="formResetToggle" class="login" name="loginForm"
        [formGroup]="icdForm" (ngSubmit)="onSubmit()" novalidate>



        <div class="card card-secondary">
          <div class="card-header">
            <h3 class="card-title">
              Company Information

            </h3>

            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>

          <div class="card-body">

            <div class="row hide">
              <div class="col-sm-4">
                <div class="form-check mb-3">
                  <input type="radio" formControlName="US_or_CA" value="US" id="US_or_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />

                  <label for="acceptTerms" class="form-check-label">US</label><br />
                  <input type="radio" formControlName="US_or_CA" value="Canada" id="US_or_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />
                  <label for="acceptTerms" class="form-check-label">Canada  <code>*</code></label>
                  <div *ngIf="submitted && f.US_or_CA.errors" class="invalid-feedback">US or Canada is required</div>
                </div>
              </div>

            </div>
            <div class="row">


              <div class="col-sm-3">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Tax_ID">F.E.I.N # (Tax ID) </label>
                  <input type="text" formControlName="Tax_ID" class="form-control"
                         [ngClass]="{'is-valid': f.Tax_ID.valid, 'is-invalid' : submitted && f.Tax_ID.valid}" placeholder="Enter Full Tax_ID" />
                  <div *ngIf="submitted && f.Tax_ID.errors" class="invalid-feedback">
                    <div *ngIf="f.Tax_ID.errors.required">Tax_ID  is required</div>
                  </div>

                </div>

              </div>
              <div class="col-sm-3">
                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-ICD_Owner_Name">ICD Owner's Name </label>
                  <input type="text" formControlName="ICD_Owner_Name" class="form-control"
                         [ngClass]="{'is-valid': f.ICD_Owner_Name.valid, 'is-invalid' : submitted && f.ICD_Owner_Name.valid}"
                         placeholder="Enter  Owner  Name"
                         appAiHint="ICD Owner Name" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.ICD_Owner_Name.errors" class="invalid-feedback">
                    <div *ngIf="f.ICD_Owner_Name.errors.required">Owner  Name is required</div>
                  </div>

                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Full_Legal_Company_Name">ICD Corporation Name </label>
                  <input type="text" formControlName="Full_Legal_Company_Name" class="form-control"
                         [ngClass]="{'is-valid': f.Full_Legal_Company_Name.valid, 'is-invalid' : submitted && f.Full_Legal_Company_Name.valid}" placeholder="Enter Full Legal Company Name"
                         appAiHint="Full Legal Company Name" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.Full_Legal_Company_Name.errors" class="invalid-feedback">
                    <div *ngIf="f.Full_Legal_Company_Name.errors.required">Full Legal Company Name  is required</div>
                  </div>

                </div>

              </div>

              <div class="col-sm-3">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Name">Hub Name</label>
                  <div class="col-md-12">
                    <input type="text" formControlName="HUB_Manager_Contact_Name" id="login-HUB_Manager_Contact_Name" name="HUB_Manager_Contact_Name" placeholder="Enter Hub Name" autocomplete="HUB_Manager_Contact_Name"
                           class="form-control"
                           appAiHint="HUB Manager Contact Name" [aiHintForm]="icdForm" />

                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-4">

                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-Reason_for_Closure">Reason for Closure<code>*</code></label>
                    <div class="col-md-12">

                      <select class="form-control" [ngClass]="{'is-valid': submitted && f.Reason_for_Closure.valid, 'is-invalid' : submitted && !f.Reason_for_Closure.valid}"
                             (change)="ChangeReason_for_Closure()"   formControlName="Reason_for_Closure" style="width: 100%;">
                        <option selected="selected" value="">Please select</option>
                        <option value="ICD OWNER OPENING NEW CORPORATION">ICD OWNER OPENING NEW CORPORATION</option>
                        <option value="LEAVING SALES NETWORK">LEAVING SALES NETWORK</option>
                        <!--<option value="INACTIVE OFFICE (Retrain)">INACTIVE OFFICE (Retrain)</option>-->
                        <option value="TBD">TBD</option>

                      </select>
                      <div *ngIf="submitted && f.Reason_for_Closure.errors" class="invalid-feedback">
                        <div *ngIf="f.Reason_for_Closure.errors.required">Reason for Closure  is required</div>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="col-sm-4">

                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-TBD_Comments">TBD Comments/Notes<span *ngIf="Keep_Insurance_Active == 'TBD'"><code>*</code></span> </label>
                    <div class="col-md-12">

                      <textarea formControlName="TBD_Comments" class="form-control" [attr.maxlength]="fieldMaxLengths.TBD_Comments"
                                placeholder="Enter TBD Comments/Notes "
                                appAiHint="Comments / Notes" [aiHintForm]="icdForm"></textarea>
                      <div class="text-right small mt-1"
                           [ngClass]="{
      'text-danger': f.TBD_Comments.errors?.maxlength,
      'text-muted': !f.TBD_Comments.errors?.maxlength
     }">

                        {{ icdForm.get('TBD_Comments')?.value?.length || 0 }}/{{ fieldMaxLengths.TBD_Comments }}

                      </div>

                      <div *ngIf="submitted && f.TBD_Comments.errors" class="invalid-feedback">
                        <div *ngIf="f.TBD_Comments.errors.required">TBD Comments/Notes  is required</div>
                        <div *ngIf="f.TBD_Comments.errors?.maxlength">
                          Maximum {{ fieldMaxLengths.TBD_Comments }} characters allowed
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

              </div>

              <div class="row">

                <div class="col-sm-6">

                  <div class="form-group">
                    <div class="col-md-12">
                      <label class="col-form-label " for="Keep_Insurance_Active">Keep Insurance Active?	<code>*</code></label>
                      <select formControlName="Keep_Insurance_Active"  (change)="ChangeInsuranceActive()" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.Keep_Insurance_Active.errors }">
                        <option value="" disabled>Please Select</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                      <div *ngIf="submitted && f.Keep_Insurance_Active.errors" class="invalid-feedback">
                        <div *ngIf="f.Keep_Insurance_Active.errors.required">Keep_Insurance_Active is required</div>
                      </div>

                    </div>
                  </div>

                </div>

                <div class="col-md-6" >
                  <div>
                    <label class="col-form-label  col-md-12" for="login-Last_Date_Insurance">Last Day of Insurance Coverage  <code>*</code></label>
                    <div class="input-group date" id="reservationdate" data-target-input="nearest">
                      <input type="text" formControlName="Last_Date_Insurance" data-target="#reservationdate" autocomplete="off"
                             id="Last_Date_Insurance" placeholder="Select Date "
                             [ngClass]="{ 'is-invalid': submitted && f.Last_Date_Insurance.errors }"
                             class="form-control"
                             required
                             appAiHint="Last Day of Insurance Coverage" [aiHintForm]="icdForm"
                             />
                      <div class="input-group-append" style="pointer-events: none;" data-target="#reservationdate" data-toggle="datetimepicker">
                        <div class="input-group-text"><i class="fa fa-calendar"></i></div>
                      </div>
                      <div *ngIf="submitted && f.Last_Date_Insurance.errors" class="invalid-feedback">
                        <div *ngIf="f.Last_Date_Insurance.errors.required">Date  is required</div>
                        <div *ngIf="f.Last_Date_Insurance.errors.pattern">Date  must be a valid date in the format MM-DD-YYYY</div>
                        <div *ngIf="f.Last_Date_Insurance.errors.dateNotLessThanToday">Date  cannot be less than today's date.</div>
                      </div>
                      </div>

                    </div>


                  </div>


                  <div class="col-sm-6">

                    <div class="form-group">
                      <div class="col-md-12">
                        <label class="col-form-label " for="Keep_Workers_Active">Keep Worker's Comp Active?	<code>*</code></label>
                        <select formControlName="Keep_Workers_Active" (change)="ChangeKeep_Workers_Active()" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.Keep_Workers_Active.errors }">
                          <option value="" disabled>Please Select</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                        <div *ngIf="submitted && f.Keep_Workers_Active.errors" class="invalid-feedback">
                          <div *ngIf="f.Keep_Workers_Active.errors.required">Keep_Workers_Active is required</div>
                        </div>

                      </div>
                    </div>

                  </div>
                  <div class="col-md-6" >
                    <div>
                      <label class="col-form-label  col-md-12" for="login-Last_Date_WC_Coverage">Last Day of WC Coverage<code>*</code></label>
                      <div class="input-group date" id="reservationdate" data-target-input="nearest">
                        <input type="text" formControlName="Last_Date_WC_Coverage" data-target="#reservationdate" autocomplete="off"
                               id="Last_Date_WC_Coverage" placeholder="Select Date "
                                [ngClass]="{ 'is-invalid': submitted && f.Last_Date_WC_Coverage.errors }"
                               class="form-control"
                               required
                               appAiHint="Last Day of WC Coverage" [aiHintForm]="icdForm"
                               />
                        <div class="input-group-append" style="pointer-events: none;" data-target="#reservationdate" data-toggle="datetimepicker">
                          <div class="input-group-text"><i class="fa fa-calendar"></i></div>
                        </div>
                        <div *ngIf="submitted && f.Last_Date_WC_Coverage.errors" class="invalid-feedback">
                          <div *ngIf="f.Last_Date_WC_Coverage.errors.required">Date  is required</div>
                          <div *ngIf="f.Last_Date_WC_Coverage.errors.pattern">Date  must be a valid date in the format MM-DD-YYYY</div>
                          <div *ngIf="f.Last_Date_WC_Coverage.errors.dateNotLessThanToday">Date  cannot be less than today's date.</div>
                        </div>
                      </div>


                    </div>


                  </div>


                  <div class="col-sm-6">

                    <div class="form-group">
                      <div class="col-md-12">
                        <label class="col-form-label " for="Keep_Payroll_Active">Keep Payroll Active?	<code>*</code></label>
                        <select formControlName="Keep_Payroll_Active" (change)="ChangeKeep_Payroll_Active()" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.Keep_Payroll_Active.errors }">
                          <option value="" disabled>Please Select</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                        <div *ngIf="submitted && f.Keep_Payroll_Active.errors" class="invalid-feedback">
                          <div *ngIf="f.Keep_Payroll_Active.errors.required">Keep_Payroll_Active is required</div>
                        </div>

                      </div>
                    </div>

                  </div>
                  <div class="col-md-6" >
                    <div>
                      <label class="col-form-label  col-md-12" for="login-Last_Date_payroll">Last Payroll Check Date<code>*</code></label>
                      <div class="input-group date" id="reservationdate" data-target-input="nearest">
                        <input type="text" formControlName="Last_Date_payroll" data-target="#reservationdate" autocomplete="off"
                               id="Last_Date_payroll" placeholder="Select Date "
                               class="form-control" [ngClass]="{ 'is-invalid': submitted && f.Last_Date_payroll.errors }"

                               required
                               appAiHint="Last Payroll Check Date" [aiHintForm]="icdForm"
                               />
                        <div class="input-group-append" style="pointer-events: none;" data-target="#reservationdate" data-toggle="datetimepicker">
                          <div class="input-group-text"><i class="fa fa-calendar"></i></div>
                        </div>
                        <div *ngIf="submitted && f.Last_Date_payroll.errors" class="invalid-feedback">
                          <div *ngIf="f.Last_Date_payroll.errors.required">Date  is required</div>
                          <div *ngIf="f.Last_Date_payroll.errors.pattern">Date  must be a valid date in the format MM-DD-YYYY</div>
                          <div *ngIf="f.Last_Date_Service.errors.dateNotLessThanToday">Date  cannot be less than today's date.</div>
                        </div>

                      </div>


                    </div>


                  </div>
                  <div class="col-md-6">

                    <label class="col-form-label  col-md-12" for="login-Last_Date_Service">Last Day Services Provided <code>*</code></label>
                    <div class="input-group date" id="reservationdate" data-target-input="nearest">
                      <input type="text" formControlName="Last_Date_Service" data-target="#reservationdate" autocomplete="off"
                             id="Last_Date_Service" placeholder="Select Date "
                             class="form-control" [ngClass]="{'is-valid': submitted && f.Last_Date_Service.valid, 'is-invalid' : submitted && !f.Last_Date_Service.valid}"
                             required
                             appAiHint="Last Day Services Provided" [aiHintForm]="icdForm"
                             />
                      <div class="input-group-append" style="pointer-events: none;" data-target="#reservationdate" data-toggle="datetimepicker">
                        <div class="input-group-text"><i class="fa fa-calendar"></i></div>
                      </div>
                      <div *ngIf="submitted && f.Last_Date_Service.errors" class="invalid-feedback">
                        <div *ngIf="f.Last_Date_Service.errors.required">Date  is required</div>
                        <div *ngIf="f.Last_Date_Service.errors.pattern">Date  must be a valid date in the format MM-DD-YYYY</div>
                        <div *ngIf="f.Last_Date_Service.errors.dateNotLessThanToday">Date  cannot be less than today's date.</div>
                      </div>


                    </div>


                  </div>
                </div>


              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Promoting_Owner">Promoting Owner<code>*</code></label>
                  <div class="col-md-12">
                    <ng-select [searchable]="true" formControlName="Promoting_Owner" (change)="onCheckboxPo($event)">
                      <ng-option *ngFor="let o of PO_namesData"
                                 [value]="o.ownerName">
                        {{ o.ownerNameCompany }}
                      </ng-option>
                    </ng-select>

                    <div *ngIf="submitted && f.Promoting_Owner.errors" class="invalid-feedback">
                      <div *ngIf="f.Promoting_Owner.errors.required">Promoting Owner is required</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Promoting_Owner">Promoting Owner's Company<code>*</code></label>
                  <div class="col-md-12">
                    <input type="text" formControlName="Promoting_Owner_Company" class="form-control"
                           [ngClass]="{'is-valid': f.Promoting_Owner_Company.valid, 'is-invalid' : submitted && f.Promoting_Owner_Company.valid}" placeholder="Enter Promoting Owner Company"
                           appAiHint="Promoting Owner Company" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.Promoting_Owner_Company.errors" class="invalid-feedback">
                      <div *ngIf="f.Promoting_Owner_Company.errors.required">Promoting  Company is required</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Regional_Consultant">Regional Consultant</label>
                  <div class="col-md-12">

                    <ng-select [searchable]="true" formControlName="Regional_Consultant"
                               (change)="onCheckboxRC($event)">
                      <ng-option *ngFor="let o of RC_namesData"
                                 [value]="o.ownerName">
                        {{ o.ownerNameCompany }}
                      </ng-option>
                    </ng-select>
                    <div *ngIf="submitted && f.Regional_Consultant.errors" class="invalid-feedback">
                      <div *ngIf="f.Regional_Consultant.errors.required">Regional Consultant is required</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Regional_Consultant">Regional Consultant's Company</label>
                  <div class="col-md-12">
                    <input type="text" formControlName="Regional_Consultant_Company" class="form-control"
                           [ngClass]="{'is-valid': f.Regional_Consultant_Company.valid, 'is-invalid' : submitted && f.Regional_Consultant_Company.valid}" placeholder="Enter Regional Consultant Company"
                           appAiHint="Regional Consultant Company" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.Regional_Consultant_Company.errors" class="invalid-feedback">
                      <div *ngIf="f.Regional_Consultant_Company.errors.required">Regional Consultant Company is required</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-National_Consultant">National Consultant<code>*</code></label>
                  <div class="col-md-12">

                    <ng-select [searchable]="true" formControlName="National_Consultant" [ngClass]="{ 'is-invalid': submitted && f.National_Consultant.errors }"
                               (change)="onCheckboxNC($event)">
                      <ng-option *ngFor="let o of NC_namesData"
                                 [value]="o.ownerName">
                        {{ o.ownerNameCompany }}
                      </ng-option>
                    </ng-select>

                    <div *ngIf="submitted && f.National_Consultant.errors" class="invalid-feedback">
                      <div *ngIf="f.National_Consultant.errors.required">National Consultant is required</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-National_Consultant_Company">National Consultant Company<code>*</code></label>
                  <div class="col-md-12">
                    <input type="text" formControlName="National_Consultant_Company" class="form-control"
                           [ngClass]="{'is-valid': f.National_Consultant_Company.valid, 'is-invalid' : submitted && f.National_Consultant_Company.valid}" placeholder="Enter Promoting Owner Company"
                           appAiHint="National Consultant Company" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.National_Consultant_Company.errors" class="invalid-feedback">
                      <div *ngIf="f.National_Consultant_Company.errors.required">Promoting  Company is required</div>
                    </div>
                  </div>
                </div>
              </div>



            </div>

          </div>

        </div>

        <div class="card card-secondary" *ngIf="selectedCountry == 'Canada' && f.Keep_Insurance_Active.value === 'No'">
          <div class="card-header">
            <h3 class="card-title">Termination Agreement</h3>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>
          <!-- /.card-header -->
          <div class="card-body">

            <div class="row">
              <div class="col-sm-4">


                <div class="form-group">
                  <label class="col-form-label col-md-12" for="login-Attach_Termination_Agreement">Attach Canadian Termination Agreement <code>*</code></label>
                  <input type="file" formControlName="Attach_Termination_Agreement" (change)="onFileSelected($event, 'Attach_Termination_Agreement')"
                         [ngClass]="{'is-valid': f.Attach_Termination_Agreement.valid  && f.Attach_Termination_Agreement.value, 'is-invalid' : submitted && !f.Attach_Termination_Agreement.valid}" 
                         class="form-control" [class.is-invalid]="isInvalid('Attach_NC_Recommendation')" />
                  <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_Termination_Agreement' }"></ng-container>
                  <div class="invalid-feedback" *ngIf="isInvalid('Attach_Termination_Agreement')">
                    <div *ngIf="icdForm.get('Attach_Termination_Agreement').errors.required"> Canadian Termination Agreement is required</div>
                    <div *ngIf="icdForm.get('Attach_Termination_Agreement').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('Attach_Termination_Agreement').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('Attach_Termination_Agreement').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>
                  <!--<a (click)="openFile(fileId, fileName)" href="#" target="_blank">Open File</a>-->

                </div>
                <div *ngIf="verificationState['Attach_Termination_Agreement'] === 'verifying'" class="mt-1 text-muted small">
                  <i class="fas fa-spinner fa-spin"></i> Verifying document...
                </div>
                <div *ngIf="verificationState['Attach_Termination_Agreement'] === 'pass'" class="mt-1 text-success small">
                  <i class="fas fa-check-circle"></i> Document verified
                </div>
                <div *ngIf="verificationState['Attach_Termination_Agreement'] === 'warn'" class="mt-1 text-warning small">
                  <i class="fas fa-exclamation-triangle"></i> Verification warning
                  <ul class="mb-0 pl-3">
                    <li *ngFor="let issue of verificationIssues['Attach_Termination_Agreement']">{{issue}}</li>
                  </ul>
                </div>
                <div *ngIf="verificationState['Attach_Termination_Agreement'] === 'warn_disabled_never_shown'" class="mt-1 text-warning small">
                  <i class="fas fa-exclamation-triangle"></i> Verification failed
                  <ul class="mb-0 pl-3">
                    <li *ngFor="let issue of verificationIssues['Attach_Termination_Agreement']">{{issue}}</li>
                  </ul>
                </div>

              </div>

              <!-- /.card-body -->
            </div>
          </div>


        </div>
 

      <!-- AI Pre-Submit Review Modal -->
      <app-pre-submit-review
        [visible]="showPreSubmitReview"
        [issues]="preSubmitIssues"
        [loading]="preSubmitLoading"
        (dismiss)="onPreSubmitDismiss()"
        (submitAnyway)="onPreSubmitDoSubmit()"
        (recheck)="onPreSubmitRecheck()"
        (autoFix)="onPreSubmitAutoFix($event)"
        (navigateToField)="onPreSubmitNavigate($event)">
      </app-pre-submit-review>
        <div class="mb-3" *ngIf="btnDisplay">


          <button type="submit" class="btn btn-success float-right">
            {{isLoading ? 'Submit' : 'Submit'}}

          </button>


        </div>

  </form>

</div>

